import type { QCResultStatsResult } from "@/modules/qc/domain/types/result";
import { Card } from "@devhop/ui";

type QCResultChartsProps = {
  stats: QCResultStatsResult;
};

export function QCResultCharts({ stats }: QCResultChartsProps) {
  const passRate =
    stats.overall.total > 0
      ? Math.round((stats.overall.pass / stats.overall.total) * 100)
      : 0;
  const failRate =
    stats.overall.total > 0
      ? Math.round((stats.overall.fail / stats.overall.total) * 100)
      : 0;

  if (stats.overall.total === 0) return null;

  return (
    <Card className="p-6" data-tourid="result-charts">
      <h2 className="mb-4 font-semibold text-lg">ອັດຕາຜ່ານ/ບໍ່ຜ່ານ</h2>
      <div className="space-y-2">
        <div>
          <div className="mb-1 flex items-center justify-between text-sm">
            <span>ຜ່ານ</span>
            <span className="font-semibold">{passRate}%</span>
          </div>
          <div className="h-6 w-full overflow-hidden rounded-full bg-muted">
            <div
              className="h-full bg-green-500 transition-all"
              style={{ width: `${passRate}%` }}
            />
          </div>
        </div>
        <div>
          <div className="mb-1 flex items-center justify-between text-sm">
            <span>ບໍ່ຜ່ານ</span>
            <span className="font-semibold">{failRate}%</span>
          </div>
          <div className="h-6 w-full overflow-hidden rounded-full bg-muted">
            <div
              className="h-full bg-red-500 transition-all"
              style={{ width: `${failRate}%` }}
            />
          </div>
        </div>
      </div>
    </Card>
  );
}
